export default __webpack_public_path__ + "static/media/pragmatic-play.ebcb491b.png";